import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post('/auth/session', { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/dashboard', { replace: true, state: { user: data } });
      } catch (e) {
        const detail = e?.response?.data?.detail || '';
        if (e?.response?.status === 403 && detail.startsWith('ACCESS_PENDING_APPROVAL')) {
          navigate('/login?status=pending', { replace: true });
          return;
        }
        console.error('Auth callback error', e);
        navigate('/login?status=error', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        Establishing session…
      </div>
    </div>
  );
}
